// extracted by mini-css-extract-plugin
export default {"page":"b91bcea6975a","pageHeader":"b4bae0882b00","permissionDenied":"bae649b75b9b","tabs":"e32b0ba9b503"};